import InputDatePicker from './InputDatePicker/InputDatePicker'
import { FormCheckbox, FormInput, FormTimePicker, FormToggle, Select } from '@conekta/ui-component-library'
import { IFormComponentTypes } from './interface'

export const FORM_COMPONENT_TYPES: IFormComponentTypes = {
  checkbox: FormCheckbox,
  date: InputDatePicker,
  email: FormInput,
  password: FormInput,
  select: Select,
  tel: FormInput,
  text: FormInput,
  time: FormTimePicker,
  toggle: FormToggle,
  url: FormInput
}
